module.exports = "https://99designs-start-assets.imgix.net/js/3d2684e7943ddd5132341b29d188756a.png";